import { NotifyHelper } from "../../../helpers/toast";
import { eKhoActionTypeDefine } from "../../action-types/category/IKhoActionTypes";
import { generateActionForKey, generateActions } from "../generateActions";

export const khoActions = {
    ...generateActions(eKhoActionTypeDefine, "KHO"),
    ...generateActionForKey(eKhoActionTypeDefine, "KHO", "SAVE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
    ...generateActionForKey(eKhoActionTypeDefine, "KHO", "DELETE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
    ...generateActionForKey(eKhoActionTypeDefine, "KHO", "SAVE_ERROR", (m) => { NotifyHelper.Error(m) }),
    ...generateActionForKey(eKhoActionTypeDefine, "KHO", "DELETE_ERROR", (m) => { NotifyHelper.Error(m) }),
}